// extracted by mini-css-extract-plugin
module.exports = {"item":"style-module--item--2yhkT","description":"style-module--description--1V0mu","itemTitle":"style-module--itemTitle--1pHTy"};